module.exports = __webpack_public_path__ + "img/twitter2.c724910a.svg";